// จุดเดียวที่เลือกฐานข้อมูล: Firebase RTDB จริง หรือ localStorage (โหมดทดลอง) — API เดียวกัน
import { fb as realFb, fk } from "./fbClient";
import { mockFb } from "./mockFb";
import { IS_MOCK } from "./config";

export const db = IS_MOCK ? mockFb : realFb;
export { fk };

export const nowIso = () => new Date().toISOString();
export const todayKey = (d = new Date()) => d.toISOString().slice(0, 10);
export const monthKey = (d = new Date()) => d.toISOString().slice(0, 7);
/** id เรียงตามเวลา (ใช้ orderByKey แบ่งหน้าได้) */
export const newId = (p = "") => p + Date.now().toString(36).padStart(9, "0") + Math.random().toString(36).slice(2, 7);

/** RTDB ไม่เก็บ array ว่าง/ค่า undefined — แปลง object {k:v} เป็นลิสต์ */
export const listOf = (obj) => Object.entries(obj || {}).map(([id, v]) => ({ id, ...(v || {}) }));
